import React, { useState } from 'react'
import { useForm } from "react-hook-form";
import {
    FormControl,
    FormErrorMessage,
    Button,
    FormLabel,
    Input,
    Text,
    Flex,
    Box,
    useColorMode
} from '@chakra-ui/core';
import { useRecoilState } from 'recoil';
import { userAtom, tokenAtom } from '../global/gloablState';
import Axios from 'axios';
import { apiUrl } from '../config/keys';
// import socketIOClient from 'socket.io-client';

// Listen to socket
// const socket =  socketIOClient(`${apiUrl}`);

const Login = ({ history }) => {
    const { handleSubmit, errors, register } = useForm();
    const { colorMode } = useColorMode();
    const [, setUser] = useRecoilState(userAtom);
    const [, setToken] = useRecoilState(tokenAtom);
    const [submitting,setSubmitting] = useState(false);

    const onSubmit = (values) => {
        setSubmitting(true);
        Axios.post(`${apiUrl}/restro/signin`, {
            _id: values.username,
            password: values.password,
        })
        .then(res => {
            console.log(res.data);
            if (!res.data.error) {
                localStorage.setItem('user', JSON.stringify(res.data.restro))
                localStorage.setItem('token', res.data.token)
                setUser(res.data.restro);
                setToken(res.data.token);
                history.push('/dashboard')
            }
        })
        setSubmitting(false);
    }
    
    return (
        <Flex align="center" justify="center" mt={5}>
            <Box borderWidth="1px" rounded="lg" overflow="hidden" boxShadow="md">

                <Box>
                    <Text
                        p={5}
                        textAlign="center"
                        fontSize="3xl"
                        fontWeight="bold"
                        color={colorMode === "dark" ? "brand.400" : "brand.500"}
                    >Login</Text>
                </Box>

                <Box bg={colorMode === "dark" ? "gray.700" : "gray.100"} p={10}>
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <FormControl m={4} isInvalid={errors.username || errors.password}>
                            <FormLabel htmlFor="username">Username</FormLabel>
                            <Input
                                name="username"
                                placeholder="username"
                                ref={register({ required: "Username is Required" })}
                            />
                            <FormErrorMessage>
                                {errors.username && errors.username.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl m={4} isInvalid={errors.username || errors.password}>
                            <FormLabel htmlFor="password">Password</FormLabel>
                            <Input
                                name="password"
                                placeholder="password"
                                ref={register({ required: "Password is required" })}
                            />
                            <FormErrorMessage>
                                {errors.password && errors.password.message}
                            </FormErrorMessage>
                        </FormControl>

                        <Button
                            mt={4}
                            ml={4}
                            rightIcon="arrow-forward"
                            variantColor="green"
                            loadingText="Logging in"
                            isLoading={submitting}
                            type="submit"
                        >
                            Submit
                        </Button>
                    </form>
                </Box>
            </Box>
        </Flex>
    )
}

export default Login
